module.exports = {"searchResponse.warning":"No subject found.","searchResponse.error":"Subjects search failed."}